import useAlchemystStoreForAi from '@/hooks/ai/client/useAlchemystStoreForAi';
import { LangChainJSON } from '@/types/ai/messages';
import { StreamedLLMResponse } from '@/types/ai/stream';
import { AlchemystStoreType } from '@/types/appStates';
import { fetchWithRewritesGenerator } from '@/utils/fetchWithRewrites';

export async function* streamLLMResponse(chatObject: {
  chat_history: LangChainJSON[];
  chatId?: string;
  tools: AlchemystStoreType['chat']['tools'];
  stream?: boolean;
  voice?: boolean;
}): AsyncGenerator<StreamedLLMResponse> {
  // Get the current store state to ensure we have the latest tools
  const currentState = useAlchemystStoreForAi.getState();
  const currentTools = currentState.chat.tools;

  const requestObject = {
    ...chatObject,
    tools: currentTools,
  };

  const llmResponse = fetchWithRewritesGenerator(
    `/api/v1/chat/generate/stream`,
    {
      method: 'POST',
      // body: JSON.stringify(chatObject),
      body: JSON.stringify(requestObject),
    }
  );

  try {
    const textDecoder = new TextDecoder();
    for await (const chunk of llmResponse) {
      await new Promise((resolve) => setTimeout(resolve, 300));
      console.log(textDecoder.decode(chunk).split('data: '));
      const text = textDecoder
        .decode(chunk)
        .split('data: ')
        .filter((data) => data.trim() !== '')
        .map((data) => data.trim());

      for (const response of text) {
        if (response === '[DONE]' || !response.startsWith('{')) {
          break;
        } else {
          const jsonChunk: StreamedLLMResponse = JSON.parse(response);
          console.log('Received:', jsonChunk);
          yield jsonChunk;
        }
      }
    }
  } catch (error) {
    console.error('Error in streaming LLM response:', error);
    throw error;
  }
}
